// extracted by mini-css-extract-plugin
module.exports = {"details":"styles_details__1mVxS","header":"styles_header__2En0K","container":"styles_container__3LWZn","info":"styles_info__3A869","info_item":"styles_info_item__1P1mH"};